import { render, staticRenderFns } from "./providers-table.vue?vue&type=template&id=c89a0046&scoped=true"
import script from "./providers-table.vue?vue&type=script&lang=js"
export * from "./providers-table.vue?vue&type=script&lang=js"
import style0 from "./providers-table.vue?vue&type=style&index=0&id=c89a0046&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89a0046",
  null
  
)

export default component.exports